// src/data.js
const data = {
  name: "Kunal Pathak",
  title: "Data Analyst",
  tagline: "I transform raw data into meaningful insights.",
  bio: "I’m a Data Science undergraduate passionate about uncovering insights from large datasets. Skilled in Python, SQL, Power BI, and data visualization, I enjoy building predictive models and dashboards that drive data-informed decision-making.",
  email: "kunalpt2004@gmail.com",
  phone: "8108375850",
  linkedin: "https://www.linkedin.com/in/kunal-pathak30",
  github: "https://github.com/Kunalpathak2004",
  projects: [
    {
      title: "Healthcare access & capacity dashboard",
      description:
        "Developed an interactive Healthcare Access & Capacity Dashboard to analyze healthcare infrastructure, hospital capacity, and regional accessibility. Built dynamic visualizations and KPIs to help identify resource gaps and support data-driven healthcare planning.",
      image: "/assets/healthcare.jpeg",
      link: "https://github.com/Kunalpathak2004/Healthcare_access_capacity_dashboard",
    },
    {
      title: "Blinkit sales analysis",
      description:
      "Blinkit Sales Analysis is an end-to-end data analytics project exploring how pricing, product categories, visibility, and outlet features affect grocery sales. Insights are showcased via an interactive Streamlit dashboard with easy navigation.",
      image: "/assets/blinkit.jpeg",
      link: "https://github.com/Kunalpathak2004/blinkit_sales_analysis",
    },
    {
      title: "Fraud Detection System",
      description:
        "Designed a machine learning pipeline to detect fraudulent transactions, boosting detection accuracy by 20%.",
      image: "/assets/project1.jpg",
      link: "https://github.com/Kunalpathak2004/Fraud-Detection-System",
    },
    {
      title: "Retail Sales Analytics",
      description:
        "Developed a Power BI dashboard integrating ETL, forecasting, and visualization to uncover business insights.",
      image: "/assets/project2.jpg",
      link: "https://github.com/Kunalpathak2004/Retail-Sales-Analytics",
    },
    {
      title: "Invalid Traffic Analysis",
      description:
        "Built an analytics dashboard to detect and visualize invalid traffic using Python and Streamlit.",
      image: "/assets/project3.jpg",
      link: "https://github.com/Kunalpathak2004/Invalid-Traffic-Analysis",
    },
  ],
  skills: ["Python", "SQL", "Power BI", "Pandas", "Scikit-learn", "Excel"],
};

export default data;
